import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom/cjs/react-router-dom.min";
import {Provider} from "react-redux";
import "./index.css";
import App from "./App";
import store from "./Store/Store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
